import { colors as c } from '@ui/colors'
import { StatusColors, StatusVariant } from './types'
import { hex } from '@ui/utils/hex'

export const statusColor: Record<StatusVariant, StatusColors> = {
  neutral: { front: c.gray[500], back: hex(c.gray[500], 0.16) },
  warning: { front: c.amber[500], back: hex(c.amber[300], 0.25) },
  danger: { front: c.red[600], back: hex(c.red[500], 0.16) },
  success: { front: c.green[600], back: hex(c.green[500], 0.16) },
  active: { front: c.blue[600], back: hex(c.blue[500], 0.16) },
  attention: { front: c.orange[600], back: hex(c.orange[500], 0.16) },
}
